import ViewPosOrder from '../../components/Sales/viewPosOrder';
import { fetchPosOrderDetail } from '../../actions/pos_actions';
import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';


let viewPosOrder = reduxForm({
    form: 'viewPosOrder',
})(ViewPosOrder);

const selector = formValueSelector('viewPosOrder');

function mapStateToProps(state) {
  return {
      posOrderDetail: state.pos.currentPosOrderDetail,
      detailIsLoading: state.salesInvoice.detailIsLoading,
      detailError: state.salesInvoice.detailError,
      userPermissions: state.auth.userPermissions,
  }
}

export default connect(mapStateToProps, { fetchPosOrderDetail })(viewPosOrder)



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/viewPosOrder.jsx